/* Public Tidio widget events only; purchase and conversation state are not read or changed.
   Ready recipe: https://developers.tidio.com/docs/widget-listeners-events
   Feature: https://developers.tidio.com/docs/widget-set-features */
(() => {
  'use strict';
  if (window.KaliaSupportLayout) return;
  window.KaliaSupportLayout = Object.freeze({ version: 2 });

  const initialized = new WeakSet();
  const qa = new URLSearchParams(window.location.search).get('kalia_support_qa') === '1';
  const trace = qa ? [] : null;
  const started = qa && window.performance ? window.performance.now() : 0;
  const metric = value => typeof value === 'number' && Number.isFinite(value) && value >= 0 ? Math.round(value) : 0;

  function record(event, size) {
    if (!qa || !document.body) return;
    const entry = {
      event,
      ms: metric((window.performance ? window.performance.now() : 0) - started),
      viewport: { width: metric(window.innerWidth), height: metric(window.innerHeight) },
      mobileWidgetHash: window.location.hash === '#mobile-widget'
    };
    // The public resize payload also contains iframe. Deliberately read only numeric dimensions.
    if (event === 'resize') entry.size = { width: metric(size?.width), height: metric(size?.height) };
    trace.push(entry);
    if (trace.length > 20) trace.shift();
    document.body.setAttribute('data-kalia-support-trace', JSON.stringify(trace));
  }

  function onReady() {
    const api = window.tidioChatApi;
    if (!api || typeof api.on !== 'function' || typeof api.setFeatures !== 'function' || initialized.has(api)) return;
    initialized.add(api);

    for (const event of ['beforeOpen', 'open', 'beforeClose', 'close', 'resize']) {
      api.on(event, size => {
        if (window.tidioChatApi !== api) return;
        if (event === 'beforeOpen' || event === 'open') document.body?.setAttribute('data-kalia-support-open', 'true');
        if (event === 'close') document.body?.removeAttribute('data-kalia-support-open');
        record(event, size);
      });
    }
    // Ready proves SDK loading, not whether a restored window is already open.
    // Do not infer that state from viewport/resize or call open/close to discover it.
    record('ready');
    try { api.setFeatures({ mobileHash: false }); } catch (_) { /* Leave the optional widget in its provider state. */ }
    // Use the public stylesheet API, scoped to the observed accessible chat region.
    // Its native 24px corner inset otherwise clips a desktop-style card in a narrow viewport.
    // The paired :has guard prevents half-applying the root constraint if the provider changes its panel markup.
    // No message styles or desktop sizes change; selectors come from the observed widget DOM.
    if (typeof api.adjustStyles === 'function') {
      try {
        api.adjustStyles('@media screen and (max-width: 749px) { [role="region"][aria-label="Chat widget"]:has(> .chat) { max-width: calc(100% - 48px) !important; } [role="region"][aria-label="Chat widget"]:has(> .chat) > .chat { width: 100% !important; max-width: 100% !important; } }');
      } catch (_) { /* An unavailable styling API must not affect chat or ordering. */ }
    }
  }

  // Follow the official ready recipe for both an existing API and later script injection.
  // Both routes may report the same load; the per-API WeakSet keeps bindings idempotent.
  document.addEventListener('tidioChat-ready', onReady);
  const existing = window.tidioChatApi;
  if (existing && typeof existing.on === 'function') existing.on('ready', () => {
    if (window.tidioChatApi === existing) onReady();
  });
})();
